<template>
<div class="chapter">
<div class="inner_page">
<div id="Frontmatter">
<p class="fm-para1">By the same author<span epub:type="pagebreak" id="page1"></span></p>
<p class="fm-para2"><i>The Scapegoat: The Life and Tragedy of a Fighting</i><br/><i>Admiral and Churchill’s role in his death</i><span epub:type="pagebreak" id="page2"></span></p>
<p class="fm-para2"><i>The Coward? The Rise and Fall of the Silver King</i></p>
<p class="fm-para2"><i>Formidable</i></p>
<p class="fm-para2"><a href="http://www.steverdunn.com" target="_blank">www.steverdunn.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Frontmatter.vue?483ecd64